import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import photo8 from '../assets/story/photo 8 - leo code - 1800px.jpg';
import './Auth.css';
import './HomePage.css';

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(formData.email, formData.password, rememberMe);
    
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error?.message || 'Erreur de connexion');
    }
    
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <Navbar />
      <div className="auth-main">
        <div className="auth-content-wrapper">
        <div className="auth-card">
          <h1>{t('auth.login')}</h1>
          {error && <div className="error-message">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">{t('auth.email')}</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">{t('auth.password')}</label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <span>{t('auth.rememberMe')}</span>
              </label>
            </div>
            <button type="submit" disabled={loading} className="submit-button">
              {loading ? 'Connexion...' : t('auth.submit')}
            </button>
          </form>
          <p className="auth-link">
            {t('auth.signup')} ? <Link to="/signup">{t('auth.signup')}</Link>
          </p>
        </div>
        <div className="login-photo-container">
          <Link to="/story" className="magnet-photo-wrapper">
            <div className="magnet"></div>
            <div className="story-image-wrapper">
              <img 
                src={photo8} 
                alt="Léo code" 
                className="story-image"
              />
              <div className="story-image-overlay">
                <p className="story-image-text">{t('login.storyLink')}</p>
              </div>
            </div>
          </Link>
        </div>
      </div>
      </div>
      <div className="homepage-navigation">
        <Link to="/blog" className="homepage-footer-link">
          Art Blog
        </Link>
        <Link to="/story" className="homepage-footer-link">
          Story
        </Link>
        <a href="https://discord.gg/PpGtKhmbjx" target="_blank" rel="noopener noreferrer" className="homepage-footer-link">
          Contact
        </a>
      </div>
      <footer className="homepage-empty-footer"></footer>
    </div>
  );
};

export default Login;

